var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66699 3.33464C8.66699 2.41416 9.41319 1.66797 10.3337 1.66797C11.2541 1.66797 12.0003 2.41416 12.0003 3.33464V3.5013C12.0003 3.77744 12.2242 4.0013 12.5003 4.0013C12.7765 4.0013 13.0003 3.77744 13.0003 3.5013V3.33464C13.0003 1.86188 11.8064 0.667969 10.3337 0.667969C8.86092 0.667969 7.66699 1.86188 7.66699 3.33464V4.66797H2.83366C1.63704 4.66797 0.666992 5.63802 0.666992 6.83464V11.8346C0.666992 13.0312 1.63704 14.0013 2.83366 14.0013H9.16699C10.3636 14.0013 11.3337 13.0312 11.3337 11.8346V6.83464C11.3337 5.63802 10.3636 4.66797 9.16699 4.66797H8.66699V3.33464ZM6.00033 10.3346C5.44806 10.3346 5.00033 9.8869 5.00033 9.33463C5.00033 8.78237 5.44806 8.33463 6.00033 8.33463C6.55259 8.33463 7.00033 8.78237 7.00033 9.33463C7.00033 9.8869 6.55259 10.3346 6.00033 10.3346Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.640c19801c6076dfcb6d1cc784987b36.svg";
export { ForwardRef as ReactComponent };